import React from 'react';
import { Dropdown } from '@ihsm/ui-shared';
import {
  DropdownButtonContainerProps,
  DropdownOption,
} from '@ihsm/ui-shared/lib/typings/shared/components/Dropdown';

export interface Props
  extends Pick<
    DropdownButtonContainerProps<string>,
    'onChange' | 'disabled' | 'value' | 'labelText' | 'verticalLayout'
  > {
  options: string[];
}

export const DropdownContainer: React.FC<Props> = ({
  options = [],
  value,
  onChange,
  disabled,
  verticalLayout,
  labelText,
}): JSX.Element => {
  const mappedOptions = options.map(
    (option): DropdownOption => ({ displayText: option, value: option })
  );

  return (
    <Dropdown
      labelText={labelText}
      options={mappedOptions}
      value={value}
      onChange={onChange}
      disabled={disabled}
      verticalLayout={verticalLayout}
    />
  );
};
